
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import InlineAlert from './inline-alert'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "inlinealert"
    }}>{`InlineAlert`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Feedback`}</p>
    <hr />
    <h2 {...{
      "id": "inline-alert"
    }}>{`Inline alert`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For communicating an important issue. They appear inline, near an issue that needs addressing. Inline alerts cannot be dismissed; they are removed by the system once the issue is resolved.`}</p>
    <Playground __position={1} __code={'<InlineAlert text=\"Alert text lede.\" description=\"Alert text description.\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      InlineAlert
    }} mdxType="Playground">
  <InlineAlert text="Alert text lede." description="Alert text description." mdxType="InlineAlert" />
    </Playground>
    <p><strong parentName="p">{`Success`}</strong></p>
    <Playground __position={2} __code={'<InlineAlert\n  text=\"Alert text lede.\"\n  description=\"Alert text description.\"\n  variant=\"success\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      InlineAlert
    }} mdxType="Playground">
  <InlineAlert text="Alert text lede." description="Alert text description." variant='success' mdxType="InlineAlert" />
    </Playground>
    <p><strong parentName="p">{`Warning`}</strong></p>
    <Playground __position={3} __code={'<InlineAlert\n  text=\"Alert text lede.\"\n  description=\"Alert text description.\"\n  variant=\"warning\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      InlineAlert
    }} mdxType="Playground">
  <InlineAlert text="Alert text lede." description="Alert text description." variant='warning' mdxType="InlineAlert" />
    </Playground>
    <p><strong parentName="p">{`Error`}</strong></p>
    <Playground __position={4} __code={'<InlineAlert\n  text=\"Alert text lede.\"\n  description=\"Alert text description.\"\n  variant=\"error\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      InlineAlert
    }} mdxType="Playground">
  <InlineAlert text="Alert text lede." description="Alert text description." variant='error' mdxType="InlineAlert" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={InlineAlert} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;